import { Waves } from "lucide-react";

export const Marquee = ({ items }) => {
    const row = [...items, ...items];
    return (
        <div data-testid="marquee" className="overflow-hidden border-y-2 border-[#1b0b06] bg-[#f23218] py-4">
            <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-8 font-display text-lg font-bold uppercase tracking-wider text-[#fbf3e8]">
                        {item}
                        <Waves size={18} className="text-[#faff00]" />
                    </span>
                ))}
            </div>
        </div>
    );
};
